import ExternalLinkIcon from 'components/ReusableComponents/Icons/ExternalLink'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Diff from 'features/Engagement/TripAdvisorRating/Diff'
import RatingBubbles from 'features/Engagement/TripAdvisorRating/RatingBubbles'
import TripAdvisorIcon from 'features/Engagement/TripAdvisorRating/TripAdvisorIcon'

import styles from './TripAdvisorRating.module.scss'

const TripAdvisorRating = ({
  isLoading,
  latestRating,
  latestNumberOfReviews,
  latestAreaRank,
  latestAreaRankOutOf,
  deltaRating,
  deltaNumberOfReviews,
  deltaAreaRank,
  reviewTripAdvisorPage
}) => {
  const tripAdvisorURL = reviewTripAdvisorPage?.replace('UserReviewEdit-', '')

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        <LoadingIndicator inline />
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <TripAdvisorIcon width={65} height={65} className={styles.tripAdvisorIcon} />
        <div>
          <div className={styles.ratingNumber}>{latestRating.toFixed(1)}</div>
          <RatingBubbles rating={latestRating} />
        </div>
      </div>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.label}>Rating</div>
          <div className={styles.value}>{latestRating.toFixed(1)} / 5</div>
          <div className={styles.change}>
            <Diff value={deltaRating} />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Review</div>
          <div className={styles.value}>{latestNumberOfReviews}</div>
          <div className={styles.change}>
            <Diff value={deltaNumberOfReviews} />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Ranking</div>
          <div className={styles.value}>
            #{latestAreaRank} of {latestAreaRankOutOf}
          </div>
          <div className={styles.change}>
            <Diff value={-deltaAreaRank} />
          </div>
        </div>
        <div className={styles.linkHolder}>
          {reviewTripAdvisorPage && (
            <a
              href={tripAdvisorURL}
              target={'_blank'}
              rel="noopener noreferrer"
              className={styles.detailsLink}
            >
              View on TripAdvisor
              <ExternalLinkIcon
                width={20}
                height={20}
                style={{ marginLeft: 4, marginTop: 1 }}
              />
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default TripAdvisorRating
